export interface LookerGroup {
    lookerGroupId: number;
    lookerGroupName: string;
}
